import React from 'react';

/**
 * OptionButton Component
 * - A button for AI text transformation options
 * - Displays an icon and label
 * - Used in the AI options menu
 */
const OptionButton = ({ label, Icon, onClick, disabled }) => (
  <button className="ai-option-button" onClick={onClick} disabled={disabled}>
    <span>{label}</span>
    <Icon size={16} />
  </button>
);

OptionButton.defaultProps = {
  disabled: false
};

export default OptionButton;
